import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Cookies from 'universal-cookie';
import CloseIcon from '../../../shared/icons/icon-close.svg';
import ReactMarkdown from '../../../shared/components/MarkdownRenderers/CustomReactMarkdown';


class BasicBanner extends Component {
  static getDomId() {
    return 'slot_header_banner';
  }

  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.state = {
      display: this.setDefaultBannerStatus(),
    };
    this.closeBanner = this.closeBanner.bind(this);
    this.setBannerClosedTime = this.setBannerClosedTime.bind(this);
  }

  setDefaultBannerStatus() {
    const bannerCookie = this.cookies.get('isShowBanner');

    if (bannerCookie) {
      const sessionId = this.cookies.get('sid');

      if (sessionId === bannerCookie) {
        return false;
      }
    }
    return true;
  }

  setBannerClosedTime() {
    const expires = new Date();
    const millisecondsInDay = 86400000;
    const sessionId = this.cookies.get('sid');

    expires.setTime(expires.getTime() + millisecondsInDay);
    this.cookies.set('isShowBanner', sessionId, {
      path: '/',
      expires,
      secure: process.env.TEST_ENV !== 'test',
      httpOnly: false,
      sameSite: 'none',
    });
  }

  closeBanner() {
    this.setBannerClosedTime();
    this.setState({
      display: false,
    });
  }

  render() {
    const { display } = this.state;
    const { message, secondaryMessage, allowClose } = this.props;
    const bannerClass = classNames({
      'site-header__banner-wrapper-basic': display,
      'site-header__banner-wrapper--hide': !display,
      'site-header__banner-wrapper--heavy': !!secondaryMessage,
    });

    return (
      <div className={bannerClass}>
        <div className="se-container">
          <div className="site-banner-basic">
            <ReactMarkdown className="site-banner__message-basic" source={message} />
            {secondaryMessage && (
              <>
                <div className="site-banner__message-seperator" />
                <ReactMarkdown className="site-banner__message-basic" source={secondaryMessage} />
              </>
            )}
            {allowClose && (
              <div
                className="site-banner__close-button"
                onClick={this.closeBanner}
                onKeyPress={this.closeBanner}
                role="button"
                tabIndex={0}
              >
                <CloseIcon className="site-banner__close-button-icon" />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

BasicBanner.propTypes = {
  message: PropTypes.string.isRequired,
  secondaryMessage: PropTypes.string,
  allowClose: PropTypes.bool,
};

BasicBanner.defaultProps = {
  secondaryMessage: null,
  allowClose: true,
};

export default BasicBanner;
